<template>
    <veui-dialog
        theme="ai"
        :open.sync="open"
        overlay-class="trial-coupon-dialog"
        @cancel="handleClose"
    >
        <div class="trial-coupon-dialog-content">
            您的新人专属 100 点券已到账，有效期 1 年<br>
            可用于合成数字人视频、AI生图、广告文案生成<br>
            快去使用吧！
        </div>
        <template #foot>
            <div
                class="ok-btn"
                @click="handleOk"
            >
                立即查看
            </div>

        </template>
    </veui-dialog>
</template>

<script>
import {Dialog} from 'veui';
import couponMixin from '@/mixins/couponMixin';
export default {
    // 在这里添加你的组件选项
    name: 'SendTrialCouponDialog',
    inject: ['model', 'alsLog'],
    mixins: [couponMixin],
    components: {
        'veui-dialog': Dialog
    },
    data() {
        return {
            open: false
        };
    },
    methods: {
        handleClose() {
            this.open = false;
            this.getCouponInfo();
        },
        handleOk() {
            this.handleClose();
            this.alsLog({
                f1: 'couponEnter',
                f2: 'click',
                f11: 'trialCouponDialog'
            });
            this.$router.push({
                name: 'orderManage'
            });
        },
        // 获取试用包
        async getTrialCoupon() {
            let result = await this.model.coupon.getTrialCoupon();
            if (!result?.data) {
                return false;
            }
            this.open = true;
        }
    },
    mounted() {
        this.getTrialCoupon();
    }
};
</script>

<style scoped lang="less">

.trial-coupon-dialog {
    /deep/ .veui-ai-dialog-content {
        width: 624px;
        height: 478px;
        box-shadow: none;
        background-color: transparent;
        background-image: url(https://qiaojiang.bj.bcebos.com/fe/static/images/messageCardBg_Try.png);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
    /deep/ .veui-ai-dialog-content-head {
        height: 145px;
        padding: 45px 95px 12px 95px;
        &-close {
            color: #A56D00;
            &:hover {
                color: #A56D00;
            }

        }
    }
    /deep/ .veui-ai-dialog-content-body {
        padding: 24px 48px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    &-content {
        padding-top: 24px;
        text-align: center;
        font-family: 'PingFang SC';
        font-size: 16px;
        line-height: 28px;
        color: #664300;
    }

    /deep/ .veui-ai-dialog-content-foot {
        height: 120px;
        padding-top: 12px;
        padding-bottom: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .ok-btn {
        width: 168px;
        height: 48px;
        border-radius: 26px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(92.43deg, #ECCD74 0%, #FDE6BA 51.23%, #E9AF46 100%);
        box-shadow: inset 0px 1px 4px rgba(255, 255, 255, 0.6);
        border: 1px solid;
        border-image-source: linear-gradient(180deg, #FFFBF1 0%, rgba(255, 255, 255, 0.5) 100%);

        font-family: 'PingFang SC';
        font-weight: 500;
        font-size: 18px;
        line-height: 26px;
        color: #664300;
        cursor: pointer;
    }

}
</style>